import consumer from './consumer';

const subscribe = (channel, options) => {
  const { connected, received } = options;

  return consumer.subscriptions.create(
    channel,
    {
      connected() {
        connected && connected();
      },
      received(data) {
        received && received(data);
      },
    },
  );
};

const disconnect = () => consumer.disconnect();

export {
  subscribe,
  disconnect,
};
